export default __webpack_public_path__ + "static/media/423.9eac9d21.gif";